import fileDownload from "src/repository/downloadFile";
import vueMainInstance from "../../main";

const namespaced = true;

const state = {
  invoices: [],
  status: ""
};

const getters = {
  invoiceList: state => state.invoices
};

const mutations = {
  setInvoiceList(state, vehicleList) {
    state.invoices = vehicleList;
  }
};

const actions = {
  loadAllInvoices({ commit }) {
    vueMainInstance.axios.get("invoice/list").then(response => {
      commit("setInvoiceList", response.data);
    });
  },
  // eslint-disable-next-line no-unused-vars
  downloadInvoiceFile({ commit }, invoice) {
    fileDownload("invoice/download?id=" + invoice.id);
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
